<template>
  <mock-up-main>
      <v-responsive
    aspect-ratio=".611"
    style="width: 100%; margin: auto; max-width: calc(100vw - 12px)"
  >

                <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.organizationName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <component
      :is="components[value.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >
      <div
        v-if="showWelcome && value?.photo?.hasWelcome"
        class="col-md-11 bg-white mx-auto d-flex"
        style="min-height: 75vh"
        key="loading"
      >
        <div class="col m-auto" v-if="value?.photo?.welcome === ''">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </div>
        <div class="m-auto" v-if="value.photo.welcome !== ''">
          <img
            class="bg-white img-fluid rounded-circle mx-auto my-auto"
            width="100"
            :src="value.photo.welcome"
            :data-source="value.photo.welcome"
            alt=""
          />
        </div>
      </div>

      <v-card
        :style="{
          background: value?.pallete?.headColor || '#ffff',
          color: value?.pallete?.textColor,
        }"
        light
        flat
        class="overflow-y-auto rounded-lg view-wrapper px-0"
        height="70vh"
        max-height="660"
      >
        <profile-photos
          :value="value.photo"
          :size="'60px'"
          class="mt-8"
        ></profile-photos>
        <div class="mx-auto text-center mb-0 pt-3 pb-0">
          <p
            :class="value && value.photo && value.photo.profile
                ? 'font-weight-bold text-center'
                : 'font-weight-bold text-center pr-6'
            "
          >
            {{ value.organizationName }}
          </p>
          <p class="pr-6 text-center">{{ value.subtitle }}</p>
        </div>
        <header-image
          :style="{
            background: value.pallete?.bodyColor,
            color: value.pallete?.textColor,
          }"
          :is-img="true"
          class="mt-0 pt-0 mx-auto"
          v-model="value.banner"
        />

        <template v-if="rerender">
          <b-gallery-view
            :new-position="true"
            :style="{
              background: value?.pallete?.bodyColor,
              color: value?.pallete?.textColor,
            }"
            class="pt-5"
            v-if="!value?.PicSelector?.slider"
            :is-img="true"
            :title="value.PicSelector?.title"
            :is-grid="value?.PicSelector?.grid"
            :description="value?.PicSelector?.description"
            :orientation ="value?.PicSelector?.orientation"
            v-model="value.gallery"
          />
          <gallery-slider
            type="gallery"
            :style="{
              background: value?.pallete?.bodyColor,
              color: value?.pallete?.textColor,
            }"
            :title="value?.PicSelector?.title"
            :description="value?.PicSelector?.description"
            :orientation ="value?.PicSelector?.orientation"
            v-model="value.gallery"
            v-else
            :new-position="true"
          />

          <show-info
            class="mt-0"
            v-model="value"
            @intersecting="showFloatBtn = !$event"
          />
        </template>
      </v-card>
    </component>

    <floating-btn
      v-if="value.socialMedia && Object.keys(value.socialMedia).length > 0"
      v-model="value.socialMedia"
      class="position-absolute"
      style="bottom: 60px; right: 35px; z-index: 5 !important"
    />
    </v-responsive>
  </mock-up-main>
</template>

<script>
import { Bus, debounce } from "../../../../../main";
import HeaderImage from "@/view/pages/otherQrTypes/photoGallery/components/headerImage";
import ShowInfo from "@/view/pages/otherQrTypes/photoGallery/components/showInfo";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryView";
import FloatingBtn from "@/view/pages/otherQrTypes/photoGallery/components/floatingBtn";
import ViewPage from "@/view/pages/businessPage/components/view/viewPage";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider.vue";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib/components";
import MockUpMain from "../../../businessPage/components/mockUp";
import ProfilePhotos from "../../../../components/repeatitive/profilePhotos";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "galleryMobile",

  components: {
    ProfilePhotos,
    MockUpMain,
    GallerySlider,
    ViewPage,
    FloatingBtn,
    BGalleryView,
    ShowInfo,
    HeaderImage,
    UniversalQrModal,
  },

  props: {
    value: Object,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data() {
    return {
      showQrDialog: false,
      showWelcome: false,
      rerender: true,
      showFloatBtn: false,
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
  },
  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value && this.value?.photo && this.value?.photo?.hasWelcome) {
        this.showWelcome = true;
        setTimeout(() => {
          this.showWelcome = false;
        }, 3000);
      }
    });
  },

  watch: {
    "value.gallery": {
      deep: true,

      handler(val) {
        debounce(() => {
          this.rerender = false;
          this.$nextTick(() => {
            this.rerender = true;
          });
        }, 2000);
      },
    },
  },
};
</script>

<style scoped>
.view-holder {
  background-color: #979797;
}

.view-wrapper::-webkit-scrollbar {
  display: none;
}

#div1 {
  display: flex;
  justify-content: center;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  height: 28px;
  width: 40%;
  margin: -1px auto 8px;
  perspective: 100px;
  z-index: 5;
}

#div2 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: -3px;
  /*border: thin solid rgba(0, 0, 0, .2);*/
  border-radius: 0 0 16px 16px;
  transform-style: preserve-3d;
  transform: rotateX(-46deg);
  z-index: 0;
  background-color: #979797;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
